import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./ChangePassword.module.css";

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import FormikControl from "../../components/FormikControl/FormikControl";
import Button from "../../components/Button/Button";
import Spinner from "../../components/Spinner/Spinner";

class Create extends Component {
  state = {
    isLoading: false,
    password: "",
  };

  setPassword = (password) => {
    this.setState({ password: password });
  };

  render() {
    const initialValues = {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    };

    const validationSchema = Yup.object({
      currentPassword: Yup.string()
        .required("This field is required")
        .trim()
        .max(14, "Password must contain only 14 characters")
        .min(7, "Password must be at least 7 characters"),
      newPassword: Yup.string()
        .required("This field is required")
        .trim()
        .max(14, "Password must contain only 14 characters")
        .min(7, "Password must be at least 7 characters"),
      confirmNewPassword: Yup.string()
        .required("This field is required")
        .trim()
        .max(14, "Password must contain only 14 characters")
        .min(7, "Password must be at least 7 characters")
        .when("newPassword", {
          is: (val) => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref("newPassword")],
            "Both password need to be the same"
          ),
        }),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = {
        current_password: values.currentPassword,
        password: values.newPassword,
      };

      axios
        .post("admins/change-password", formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>Change Password | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Change Password</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>Change Password</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Change Password</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className={["FormContainer", styles.FormContainer].join(" ")}>
              <Formik
                key={this.state.formId}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                render={() => {
                  return (
                    <Form>
                      <div className={["FormBody", styles.FormBody].join(" ")}>
                        <FormikControl
                          control="password"
                          type="password"
                          label="Current Password"
                          name="currentPassword"
                          autocomplete="new-password"
                        />

                        <FormikControl
                          control="passwordStrength"
                          type="password"
                          label="New Password"
                          name="newPassword"
                          setPassword={this.setPassword}
                          password={this.state.password}
                        />

                        <FormikControl
                          control="password"
                          type="password"
                          label="Confirm New Password"
                          name="confirmNewPassword"
                        />
                      </div>
                      <div className="FormActions">
                        <Button btnType="Primary" type="Submit" width="W100">
                          Save
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              />
            </div>
          </div>
        </div>
        <Spinner isLoading={this.state.isLoading} />
        <ToastContainer />
      </div>
    );
  }
}

export default Create;
